import React, { Component } from 'react';
import PropTypes from 'prop-types';
import moment from 'moment';
import isEmpty from 'lodash/isEmpty';
import isNull from 'lodash/isNull';
import isEqual from 'lodash/isEqual';
import debounce from 'lodash/debounce';
import Toggle from 'react-toggle';
import Dots from 'react-activity/lib/Dots';
import convertFromHTML from 'html-to-draftjs';
import sanitizeHtml from 'sanitize-html';
import EditorState from 'draft-js/lib/EditorState';
import ContentState from 'draft-js/lib/ContentState';
import { extractEditorContentToHTML } from '../shared/Editor/utils';
import { DivisionLabel } from '../shared/styled-components';
import styles from '../shared/styles';
import Status from './status';
import UploadRecord from './uploadrecord';
import Title from '../shared/Title';
import Description from './description';
import Notes from './notes';
import Coverart from './coverart';
import AudioProcessing from './audioprocessing';
import AudioPlayback from './Audioplayback';
import PublishButton from './PublishButton';
import ReleaseInterval from './ReleaseInterval';
import { Select } from '../shared/styled-components';
import Loading from '../../../../components/Loading';
import BeforeUnload from '../../../../components/BeforeUnload';
import { RowDivision, LoadingWrapper, HigherPlanTag } from '../../../../styles/styled';
import {
  isEpisodeScheduled,
  episodeHasRealtimeProps,
  applyEpisodeRealtimeProps,
} from '../../../../helpers/episodes';
import { episodeManager } from '../../../../helpers/managers';
import {
  canUserAccessFeature,
  getManagedEpisodeById,
  getHighestEpisodeIndex,
} from '../../../../helpers/userinfoHelper';
import Axios from 'axios';
import { ALERTS } from '../../../../helpers/texts';
import AudioEdit from './AudioEdit';
const {
  generateEpisodeId,
  isSoundcastDripped,
} = require('../../../../../server/scripts/utils.js')();
const { loadSoundcastEpisodesMaxIndex } = require('./miscUtils.js');

const emptyState = {
  episodeId: null,
  index: null,
  soundcastId: '',
  soundcast: null,
  editSoundcastId: null, // when editmode === true
  editIndex: null,       // when editmode === true

  title: '',
  description: EditorState.createEmpty(),
  actionstep: '',
  recordedAudioUrl: '',
  uploadedAudioUrl: '',
  coverArtUrl: '',
  notesUrl: '',
  publicEpisode: false,
  audioDuration: 0,
  audioImported: false,
  audioNormalization: false,
  trimSilence: false,
  reduceSilence: false,
  addIntroOutro: false,
  silentPeriod: 0.5,
  overlayDuration: 5,
  releaseInterval: 0,

  editmode: null, // <-- this.props.editmode
  // specific for editmode
  isPublished: false,
  isPublishedOld: false,
  isLaterPublishOld: false,
  publishOn: null,
  date_created: null,
  date_published: null,
  audioProcessing: false,
  url: '', // url of the episode
  editedUrl: '',
  episodeState: '',
  hasUpdatedAudio: '',
  hasProcessOfUpdateAudio: false,

  emailListeners: false,
  audioSourceType: 'upload',
  mergedRealtime: false,
  dirty: false,
  savingInProgress: false,
  changeSoundcast: false,
};

class SingleEpisode extends Component {
  constructor(props) {
    super(props);

    this.state = emptyState;

    this.inputSaveDebounceHandler = debounce(this.saveEpisode, 800);

    this.onChangeSoundcastId = this.onChangeSoundcastId.bind(this);
    this.deleteEpisode = this.deleteEpisode.bind(this);
    this.changeSharingSettings = this.changeSharingSettings.bind(this);
    this.setProcessingOption = this.setProcessingOption.bind(this);
    this.onEpisodeStateChange = this.onEpisodeStateChange.bind(this);
    this.onFilepondProcess = this.onFilepondProcess.bind(this);
    this.onFilepondFileRemove = this.onFilepondFileRemove.bind(this);
    this.onFileForceRemove = this.onFileForceRemove.bind(this);
    this.onFileImportRemove = this.onFileImportRemove.bind(this);
    this.onFileImportComplete = this.onFileImportComplete.bind(this);
    this.onEditorStateChange = this.onEditorStateChange.bind(this);
    this.onEpisodeInputChange = this.onEpisodeInputChange.bind(this);
    this.saveEpisode = this.saveEpisode.bind(this);
    this.showModal = this.showModal.bind(this);
    this.handleSaveUpdateBtns = this.handleSaveUpdateBtns.bind(this);
  }

  componentDidMount() {
    const { editmode, match, history } = this.props;
    let editSoundcastId = null;
    if (editmode) {
      const { id: episodeId } = match.params;
      const episode = isEmpty(episodeId) ? null : getManagedEpisodeById(episodeId);
      if (isEmpty(episode)) {
        return history.replace(`/dashboard/soundcasts`);
      }

      const soundcastId = episode.soundcastID || episode.soundcastId || null;
      const index = episode.index || null;

      editSoundcastId = soundcastId;
      const editIndex = index;

      this.setState({
        editmode,
        episodeId,
        soundcastId,
        index,
        editSoundcastId,
        editIndex,
      }, async () => {
        await this.handleDefaultEpisode(episodeId, episode);
        this.changeSoundcastId(soundcastId);
      });
    } else {
      this.setState({
        editmode,
        episodeId: generateEpisodeId(),
      }, () => {
        if (!isEmpty(this.props.userInfo)) {
          const soundcastId = editSoundcastId || this.getDefaultSoundcastId();
          if (!isEmpty(soundcastId)) {
            this.changeSoundcastId(soundcastId);
          }
        }
      });
    }
  }

  componentDidUpdate(_, prevState) {
    const { editmode, match, history } = this.props;

    if ((editmode && !this.state.editmode) || (!editmode && this.state.editmode)) {
      this.setState({
        ...emptyState,
        editmode,
      }, async () => {
        this.componentDidMount();
      });
    }
  }

  async handleDefaultEpisode( episodeId, episode ) {
    const { history, addUpdateManagedSoundcastEpisode } = this.props;
    // edit mode goes here
    try {
      const {
        soundcastId,
        index,
        title,
        description = '',
        actionstep = '',
        coverArtUrl = '',
        notes: notesUrl = '',
        publicEpisode,
        isPublished = false,
        date_created,
        date_published = null,
        audioProcessing,
        url,
        editedUrl,
        episodeState,
        publishOn = null,
        releaseInterval = 0,
        emailListeners = false,
      } = await new Promise(async resolve => {
        if (episodeHasRealtimeProps(episode)) {
          return resolve(episode);
        }

        const nepisode = await applyEpisodeRealtimeProps(episode);
        const soundcast = this.getSoundcastById(nepisode.soundcastId);

        // update the redux tree for applied real time props
        addUpdateManagedSoundcastEpisode(soundcast, nepisode);
        resolve(nepisode);
      });

      let ndescription = EditorState.createEmpty();
      if (!isEmpty(description)) {
        // sanitized html description
        const disallowedTags = ['figure'];
        const allowedTags = (sanitizeHtml.defaults.allowedTags || [])
          .concat(['img'])
          .filter(tag => !disallowedTags.includes(tag));
        const allowedAttributes = {
          ...(sanitizeHtml.defaults.allowedAttributes || {}),
          'p': ["style"],
          'span': ["style"],
        };
        const allowedStyles = {
          ...(sanitizeHtml.defaults.allowedStyles || {}),
          '*': {
          // Match HEX and RGB
          'color': [/^#(0x)?[0-9a-f]+$/i, /^rgb\(\s*(\d{1,3})\s*,\s*(\d{1,3})\s*,\s*(\d{1,3})\s*\)$/],
          'text-align': [/^left$/, /^right$/, /^center$/],
          // Match any number with px, em, or %
          'font-size': [/^\d+(?:px|em|%)$/]
          },
          'p': {
          'font-size': [/^\d+rem$/],
          },
        };
        const sanitizeOptions = {
          allowedAttributes,
          allowedTags,
          allowedStyles,
        };
        const sanitized = sanitizeHtml(description, sanitizeOptions).trim();

        // if the first tag is img, prepend a p tag
        // a temp fix to the draftEntity error of draftjs
        const content = sanitized.search('<img') === 0 ? `<p></p>${sanitized}` : sanitized;
        const { contentBlocks, entityMap } = convertFromHTML(content);
        const contentState = ContentState.createFromBlockArray(contentBlocks, entityMap);
        ndescription = EditorState.createWithContent(contentState);
      }

      this.setState(
        {
          episodeId,
          index,
          title,
          description: ndescription,
          actionstep,
          coverArtUrl,
          notesUrl,
          publicEpisode,
          isPublished,
          isPublishedOld: isPublished,
          isLaterPublishOld: isEpisodeScheduled({ publishOn }),
          date_created,
          date_published,
          audioProcessing,
          url,
          editedUrl, // for when the auto has been processed
          episodeState,
          emailListeners,
          publishOn,
          releaseInterval,
          mergedRealtime: true,
        },
        () => this.changeSoundcastId(soundcastId)
      );
    } catch (e) {
      console.error('Error', e.message);
      // in case it fails, we still to assign episodeId
      this.setState({ episodeId: generateEpisodeId() }, () => {
        this.showModal({
          title: 'Unknown Track',
          content: 'Failed to load track details, please contact soundwise support.',
          onClose: () => history.goBack(),
        });
      });
    }
  }

  getAudioUrl() {
    const { uploadedAudioUrl = '', recordedAudioUrl = '' } = this.state;
    if (!isEmpty(uploadedAudioUrl)) {
      return uploadedAudioUrl;
    }

    if (!isEmpty(recordedAudioUrl)) {
      return recordedAudioUrl;
    }

    return '';
  }

  areRequiredFieldsValid() {
    const { editmode } = this.props;
    const { title } = this.state;
    const fields = [title];

    // on non edit mode, both url title are required
    if (!editmode) {
      fields.push(this.getAudioUrl());
    }

    return [...fields].every(value => !isEmpty(value));
  }

  onEpisodeStateChange(key = 'title', value = '', cb = () => {}) {
    return () => {
      const oldstatevalue = this.state[key];
      this.setState({ [key]: value }, () => {
        cb(oldstatevalue);
      });
    };
  }

  handleDefaultSoundcast() {
    const { userInfo } = this.props;
    const soundcastId = this.getDefaultSoundcastId();
    if (userInfo && !isEmpty(soundcastId)) {
      this.changeSoundcastId(soundcastId);
    }
  }

  showModal(metadata = {}) {
    this.props.modalHandler({
      show: true,
      ...metadata,
    })();
  }

  hasAudioProcessing() {
    const { audioNormalization, trimSilence, reduceSilence, addIntroOutro } = this.state;
    return audioNormalization || trimSilence || reduceSilence || addIntroOutro ? true : false;
  }

  deleteEpisode() {
    this.props.onDeleteEpisode(this.state.episodeId, this.state.soundcastId);
  }

  async updateEpisode({ willPublish = false, rePublish = false }, extraEpisode = {}) {
    const {
      episodeId,
      title,
      soundcastId,
      description,
      actionstep,
      notesUrl: notes,
      publicEpisode,
      date_created,
      date_published,
      isPublishedOld,
      isLaterPublishOld,
      coverArtUrl,
      publishOn,
      releaseInterval,
      hasUpdatedAudio,

      emailListeners,
      audioNormalization,
      trimSilence,
      reduceSilence,
      addIntroOutro,
      silentPeriod,
      overlayDuration,
      index,
    } = this.state;
    const { finalupdate = false } = extraEpisode || {};

    const soundcast = this.getSoundcastById(soundcastId);
    const episode = {
      episodeId,
      title,
      description: extractEditorContentToHTML(description.getCurrentContent()),
      actionstep: actionstep.length > 0 ? actionstep : '',
      notes,
      publicEpisode,
      date_created: !isPublishedOld && willPublish ? moment().format('X') : date_created,
      date_published,
      isPublished: finalupdate ? willPublish : isPublishedOld,
      coverArtUrl,
      soundcastID: soundcastId,
      isPublishedOld,
      isLaterPublishOld,
      publishOn,
      releaseInterval,
      hasUpdatedAudio,
      willPublish,
      redoProcessing: this.hasAudioProcessing(),
      emailListeners,
      audioNormalization,
      trimSilence,
      reduceSilence,
      addIntroOutro,
      silentPeriod,
      overlayDuration,
      ...extraEpisode,
      index,
    };

    try {
      this.props.realUpdateEpisode(episode, { soundcastId, ...soundcast }, rePublish );
    } catch (err) {
      console.error('Error: There was a problem updating episode', err);

      // only show errors when final update and not preupdate
      const { finalupdate = false } = extraEpisode || {};
      if (!finalupdate) return;

      this.showModal({
        content: 'Something went wrong when updating the track. Please try again.',
      });
    }
  }

  async saveEpisode(extraEpisode = {}, extraSoundcast = {}) {
    const {
      episodeId,
      index,
      title,
      description,
      actionstep,
      audioDuration,
      recordedAudioUrl,
      notesUrl,
      coverArtUrl,
      publicEpisode,
      audioNormalization,
      trimSilence,
      reduceSilence,
      addIntroOutro,
      silentPeriod,
      overlayDuration,
      emailListeners,
      soundcastId,
      soundcast,
      episodeState,
      publishOn,
      releaseInterval,
      savingInProgress,
    } = this.state;

    if (savingInProgress) {
      console.warn(`WARNING: saving episode data is already in progress`);
      return;
    }

    this.setState({ savingInProgress: true });

    if (isEmpty(soundcastId)) {
      return this.showModal({
        title: 'Missing properties',
        content:
          'Some of the required properties are missing. Please reload the page. If this keeps happening contact support immediately',
      });
    }

    // when we are saving it as draft
    // if the episodeState is already 'ready'
    // do not reupdate the episodeState anymore
    if (episodeState !== 'ready') {
      const state = await episodeManager.getProp(episodeId, 'episodeState', '');
      if (state === 'ready') {
        // console.log('Episode is ready', state);
        extraEpisode.episodeState = state;
        this.setState({
          episodeState: state,
        });
      }
    }

    const episode = {
      id: episodeId,
      index,
      title,
      description: extractEditorContentToHTML(description.getCurrentContent()),
      actionstep,
      duration: audioDuration,
      episodeUrl: this.getAudioUrl(),
      notesUrl,
      coverArtUrl,
      soundcastID: soundcastId,
      audioProcessing: this.hasAudioProcessing(),
      public: publicEpisode,
      isPublished: false,
      audioNormalization,
      trimSilence,
      reduceSilence,
      addIntroOutro,
      silentPeriod,
      overlayDuration,
      emailListeners,
      episodeState,
      publishOn,
      releaseInterval,
      isSingleEpisode: true,
      ...extraEpisode,
    };
    const { finalsave = false } = extraEpisode || {};

    // tells if the audio is recorded
    if (!isEmpty(recordedAudioUrl)) {
      episode.recorded = true;
    }

    try {
      await this.props.realSaveEpisode(episode, {
        soundcastId,
        ...soundcast,
        ...extraSoundcast,
      });
    } catch (err) {
      console.error('Error: There was a problem saving episode', err);

      // only show error when final saving and not presave
      if (finalsave) {
        this.showModal({
          content: 'Something went wrong when updating the track. Please try again.',
        });
      }
    } finally {
      // this disables dirty saving after final save
      if (!finalsave) {
        this.setState({ savingInProgress: false });
      }
    }
  }

  getNameWithoutExtension(filename) {
    return filename.split('.').slice(0, -1).join('.') || filename + '';
  }

  onChangeSoundcastId(e) {
    this.changeSoundcastId(e.target.value);
  }

  changeSoundcastId(soundcastId) {
    const { editmode } = this.props || {};
    const { episodeId, editSoundcastId = null, editIndex = null } = this.state || {};
    const soundcast = this.getSoundcastById(soundcastId);

    this.setState({ changeSoundcast: true }, () => {
      this.setState({
        soundcast,
        soundcastId,
        publicEpisode: editmode ? this.state.publicEpisode : false,
      }, async () => {
        const isDefSoundcast = (!isEmpty(editSoundcastId) && editSoundcastId === soundcastId);
        let index = 1;
        if (editmode && isDefSoundcast) {
          index = !isNull(editIndex) ? editIndex
            : !isEmpty(episodeId) ? await episodeManager.getProp(episodeId, 'index', 1)
            : 1;
        } else {
          index = await loadSoundcastEpisodesMaxIndex(soundcastId) + 1;
        }
        this.setState({
          changeSoundcast: false,
          index,
        });
      });
    });

  }

  getSoundcastById(soundcastId) {
    const { soundcastsManaged = [] } = this.props;
    if (!isEmpty(soundcastsManaged)) {
      const soundcast = soundcastsManaged.find(soundcast => isEqual(soundcast.id, soundcastId));
      if (soundcast) {
        return soundcast;
      }
    }

    return {};
  }

  changeSharingSettings() {
    const { publicEpisode } = this.state;
    this.setState({ publicEpisode: !publicEpisode, dirty: true }, () => {
      if (!this.props.editmode) {
        this.saveEpisode();
      }
    });
  }

  setProcessingOption(option, value) {
    return () => {
      if (!canUserAccessFeature('EPISODE_PROCESSING')) {
        return this.showModal({
          title: 'Upgrade Required',
          content: ALERTS().EPISODE_PROCESSING.NO_ACCESS,
          upgrade: true,
        });
      }

      this.setState({ [option]: value, dirty: true }, () => {
        if (!this.props.editmode) {
          this.saveEpisode();
        }
      });
    };
  }

  onFilepondProcess(statekey) {
    return (error, filepond) => {
      if (error) {
        return console.log('Unable to process file', error);
      }

      const { serverId } = filepond;
      if (!isEmpty(serverId)) {
        let { url } = JSON.parse(serverId);
        this.setState({ [statekey]: url, dirty: true }, () => {
          if (!this.props.editmode) {
            this.saveEpisode();
          }
        });
      }
    };
  }

  onFilepondFileRemove(statekey = 'uploadedAudioUrl') {
    return () => {
      this.setState({ [statekey]: '', audioDuration: 0, dirty: true }, () => {
        if (statekey === 'uploadedAudioUrl') {
          this.deleteEpisode();
        } else {
          if (!this.props.editmode) {
            this.saveEpisode();
          }
        }
      });
    };
  }

  onFileForceRemove(statekey = 'coverArtUrl') {
    return async () => {
      try {
        // delete the actual file
        const targetUrl = this.state[statekey];
        await Axios.delete('/api/uploadv2', {
          headers: {
            'Content-Type': 'text/plain',
          },
          data: { url: targetUrl },
        });

        this.setState({ [statekey]: '', dirty: true }, this.updateEpisode);
      } catch (err) {
        console.log(`Error removing ${statekey}`, err.message);
        this.showModal({
          content: 'Something went wrong when removing the file. Please try again.',
        });
      }
    };
  }

  onFileImportRemove(statekey) {
    return () => {
      this.setState({ [statekey]: '', dirty: true }, () => {
        if (statekey === 'uploadedAudioUrl') {
          // remove additional states
          this.setState(
            { audioDuration: 0, audioImported: false, dirty: true },
            this.deleteEpisode
          );
        } else {
          if (!this.props.editmode) {
            this.saveEpisode();
          }
        }
      });
    };
  }

  onFileImportComplete(statekey) {
    return ({ url }) => {
      // console.log('onFileImportComplete', statekey, url);
      this.setState({ [statekey]: url, dirty: true }, () => {
        if (!this.props.editmode) {
          this.saveEpisode();
        }
      });
    };
  }

  onEditorStateChange(description = '') {
    if (description && !isEmpty(description)) {
      this.setState({ description, dirty: true }, this.inputSaveDebounceHandler);
    }
  }

  onEpisodeInputChange(key = 'title', raw = false) {
    return e => {
      const input = !raw ? e.target.value : e;
      this.setState({ [key]: input || '', dirty: true }, this.inputSaveDebounceHandler);
    };
  }

  getDefaultSoundcastId() {
    const { userInfo = {}, soundcastsManaged = [], location } = this.props;

    if (isEmpty(userInfo) || isEmpty(soundcastsManaged)) {
      return '';
    }

    if (location.state && location.state.soundcastID) {
      return location.state.soundcastID;
    }

    return soundcastsManaged[0].id;
  }

  renderAudioHandler() {
    return (
      <UploadRecord
        episodeId={this.state.episodeId}
        activeTab={this.state.audioSourceType}
        onChangeTab={key => this.onEpisodeStateChange('audioSourceType', key)()}
        uploader={{
          onUploadStart: ({ source }) => {
            this.setState(({ title = '' }) => ({
              recordedAudioUrl: '',
              title: !isEmpty(title) ? title : this.getNameWithoutExtension(source.name),
            }));
          },
          onUploadComplete: (uploadedAudioUrl, audioDuration) => {
            this.setState(
              {
                uploadedAudioUrl,
                audioDuration,
                recordedAudioUrl: '',
              },
              () => {
                if (!this.props.editmode) {
                  this.saveEpisode();
                }
              }
            );
          },
          onUploadRemove: this.onFilepondFileRemove('uploadedAudioUrl'),
          onImportRemove: this.onFileImportRemove('uploadedAudioUrl'),
          onImportComplete: metadata => {
            this.setState(
              {
                audioDuration: 0,
                audioImported: true,
                title: decodeURIComponent(metadata.filename),
              },
              () => this.onFileImportComplete('uploadedAudioUrl')(metadata)
            );
          },
        }}
        recorder={{
          onRecordingRemove: () => {
            this.setState({ recordedAudioUrl: '', audioDuration: 0 }, this.deleteEpisode);
          },
          onRecordingComplete: (recordedAudioUrl, audioDuration) => {
            this.setState(
              ({ title = '' }) => ({
                title: !isEmpty(title) ? title : 'Audio recording',
                episodeState: 'ready',
                recordedAudioUrl,
                audioDuration,
                uploadedAudioUrl: '',
              }),
              () => {
                if (!this.props.editmode) {
                  this.saveEpisode();
                }
              }
            );
          },
          accessible: canUserAccessFeature('EPISODE_RECORDING'),
        }}
      />
    );
  }

  renderAudioEditor() {
    const { url, editedUrl, isPublished, publicEpisode, episodeId, episodeUrl } = this.state;

    return (
      <AudioEdit
        original={url}
        edited={editedUrl}
        published={isPublished}
        publicEpisode={publicEpisode}
        episodeId={episodeId}
        onUploadStart={() => this.setState({ hasProcessOfUpdateAudio: true })}
        onUploadComplete={() =>
          this.setState({ hasUpdatedAudio: true, hasProcessOfUpdateAudio: false })
        }
        onUploadRemove={() =>
          this.setState({ hasUpdatedAudio: false, hasProcessOfUpdateAudio: false })
        }
        onUploadError={() =>
          this.setState({ hasUpdatedAudio: false, hasProcessOfUpdateAudio: false })
        }
      />
    );
  }

  renderReleaseInterval() {
    const { soundcast, releaseInterval, date_published } = this.state;

    // if soundcast is not dripped, don't render this field
    if (!isSoundcastDripped(soundcast)) {
      return null;
    }

    // if the episode has been published, don't render this field
    if (!isNull(date_published)) {
      return null;
    }

    return (
      <ReleaseInterval
        value={Number(releaseInterval)}
        onChange={this.onEpisodeInputChange('releaseInterval', true)}
      />
    );
  }

  renderEmailNotif() {
    const { emailListeners } = this.state;
    const allowed = canUserAccessFeature('EMAIL_TO_LISTENERS');
    return (
      <RowDivision className="row">
        <div className="col-lg-9 col-md-9 col-sm-12 col-xs-12">
          <div style={styles.toggleOptionsContent}>
            <Toggle
              className="toggle-green"
              id="share-status"
              aria-labelledby="share-label"
              // label="Charge subscribers for this soundcast?"
              checked={emailListeners}
              onChange={() => this.setState({ emailListeners: !emailListeners })}
              disabled={!allowed}
            />
            <span id="share-label" style={{ fontSize: 16, fontWeight: 800, marginLeft: '0.5em' }}>
              Send email notification to subscribers and invitees after publishing
            </span>
            {!allowed && <HigherPlanTag className="margin-one-left" />}
          </div>
        </div>
      </RowDivision>
    );
  }

  renderAudioProcessing() {
    const { editmode } = this.props;
    const {
      isPublished,
      date_published,
      editedUrl = '',
      episodeState,
      hasUpdatedAudio,
      audioProcessing,
    } = this.state;

    // do not render audio processing if
    // the episode is published
    // the episode is in draft mode but has been published
    if (editmode) {
      const isProcessing = episodeState === 'processing' || audioProcessing === true;
      const wasPublished = !isPublished && date_published && isEmpty(editedUrl);
      if (isPublished || wasPublished || isProcessing || hasUpdatedAudio) {
        return null;
      }
    }

    const {
      soundcast,
      trimSilence,
      audioNormalization,
      reduceSilence,
      silentPeriod,
      overlayDuration,
      addIntroOutro,
    } = this.state;

    return (
      <AudioProcessing
        accessible={canUserAccessFeature('EPISODE_PROCESSING')}
        soundcast={soundcast}
        trimSilence={trimSilence}
        audioNormalization={audioNormalization}
        reduceSilence={reduceSilence}
        silentPeriod={silentPeriod}
        overlayDuration={overlayDuration}
        addIntroOutro={addIntroOutro}
        onChangeOption={this.setProcessingOption}
        onNoIntroOutroAlert={() => {
          this.showModal({
            title: 'Missing intro or outro requirements',
            content: 'Please upload intro/outro clip(s) to your soundcast to use this feature.',
          });
        }}
      />
    );
  }

  handleSaveUpdateBtns(publish, publishOn = null, rePublish = false) {
    return () => {
      // before we proceed verify the required props first
      const canProceed = this.areRequiredFieldsValid();
      if (!canProceed) {
        return this.showModal({
          content: 'Please fill in all the required fields to continue.',
        });
      }

      this.setState({ publishOn, dirty: false }, () => {
        const { editmode } = this.props;
        // console.log('handleSaveUpdateBtns', publish, editmode);
        if (editmode) {
          this.updateEpisode({ willPublish: publish, rePublish }, { finalupdate: true });
        } else {
          this.saveEpisode({ isPublished: publish, complete: true, finalsave: true });
        }
      });
    };
  }

  renderSaveButtons() {
    const { editmode, saving, userInfo } = this.props;
    const { isPublished, publishOn, hasProcessOfUpdateAudio, date_published } = this.state;
    let content = (
      <div className="col-lg-12" style={{ textAlign: 'center' }}>
        <div style={{ fontSize: 17, width: '100%', marginTop: 50 }}>
          <span>{hasProcessOfUpdateAudio ? 'Updating audio' : 'Saving'}</span>
        </div>
        <div className="" style={{ marginTop: 10, width: '100%' }}>
          <Dots color="#727981" size={32} speed={1} />
        </div>
      </div>
    );

    if (!saving && !hasProcessOfUpdateAudio) {
      const hasPublishLater = editmode ? !isPublished : true;
      const hasRepublish = editmode && !isNull(date_published);

      content = (
        <React.Fragment>
          <div className="col-lg-12" style={{ textAlign: 'center' }}>
            <div
              id="createEpisodeSaveDraftTestBtn"
              className="btn"
              disabled={hasProcessOfUpdateAudio}
              style={styles.draftButton}
              onClick={this.handleSaveUpdateBtns(false)}>
              <span>Save Draft</span>
            </div>
          </div>
          <div className="col-lg-12" style={{ textAlign: 'center' }}>
            <PublishButton
              userInfo={userInfo}
              showModal={this.showModal}
              hasPublishLater={hasPublishLater}
              publishOn={publishOn}
              disabled={hasProcessOfUpdateAudio}
              // onPublishNow={this.handleSaveUpdateBtns(true)}
              hasRepublish={hasRepublish}
              onPublishNow={params => {
                const { rePublish = false } = params || {};
                this.handleSaveUpdateBtns(true, null, rePublish)();
              }}
              onPublishLater={publishOn => {
                this.handleSaveUpdateBtns(false, publishOn)();
              }}
            />
          </div>
        </React.Fragment>
      );
    }

    return <div style={styles.actionButtonWrapper}>{content}</div>;
  }

  render() {
    const { saving, editmode, soundcastsManaged = [] } = this.props;
    const {
      soundcast,
      episodeId,
      episodeUrl,
      publicEpisode,
      title,
      description,
      coverArtUrl,
      notesUrl,
      mergedRealtime,
      dirty,
      changeSoundcast = false,
    } = this.state;

    if (isEmpty(soundcast) || changeSoundcast) {
      return (
        <RowDivision className="row">
          <LoadingWrapper height="80">
            <Loading text="Obtain episode index, please wait..." />
          </LoadingWrapper>
        </RowDivision>
      );
    }

    if (editmode && !mergedRealtime) {
      return (
        <RowDivision className="row">
          <LoadingWrapper height="80">
            <Loading text="Loading Track..." />
          </LoadingWrapper>
        </RowDivision>
      );
    }

    return (
      <>
        <RowDivision className="row">
          <div id="soundcast-parent" className="col-lg-9 col-md-9 col-sm-12 col-xs-12">
            <div style={styles.soundcastSelectWrapper}>
              <div style={styles.notesLabel}>Publish in</div>
              <Select
                value={this.state.soundcastId || ''}
                style={styles.soundcastSelect}
                onChange={this.onChangeSoundcastId}>
                {isEmpty(soundcastsManaged) && <option>Loading...</option>}
                {soundcastsManaged.map((soundcast, i) => {
                  return (
                    <option value={soundcast.id} key={i}>
                      {soundcast.title}
                    </option>
                  );
                })}
              </Select>
            </div>
          </div>
        </RowDivision>
        <Status
          episodeId={episodeId}
          public={publicEpisode}
          onStatusChange={this.changeSharingSettings}
          viewLinks={editmode}
        />
        {this.renderEmailNotif()}
        {!editmode && this.renderAudioHandler()}
        <Title value={title} required={true} onChange={this.onEpisodeInputChange('title')} />
        <Description
          value={description}
          placeholder="Description of your track"
          onChange={this.onEditorStateChange}
        />
        <RowDivision className="row">
          <div id="action-steps" className="col-lg-9 col-md-9 col-sm-12 col-xs-12">
            <DivisionLabel>Action step</DivisionLabel>
            <textarea
              style={styles.actionsInput}
              placeholder="Include any actions you want your audience to take after listening"
              onChange={this.onEpisodeInputChange('actionstep')}
              value={this.state.actionstep}
            />
          </div>
        </RowDivision>
        <Notes
          episodeId={episodeId}
          value={notesUrl}
          onUploadComplete={this.onFilepondProcess('notesUrl')}
          onUploadRemove={this.onFilepondFileRemove('notesUrl')}
          onUploadError={this.onFilepondFileRemove('notesUrl')}
          onFileRemove={this.onFileForceRemove('notesUrl')}
          onImportComplete={this.onFileImportComplete('notesUrl')}
          onImportRemove={this.onFileImportRemove('notesUrl')}
          onImportError={this.onFileImportRemove('notesUrl')}
          persistUploaderOnSuccess={!editmode}
        />
        <Coverart
          episodeId={episodeId}
          value={coverArtUrl}
          onUploadComplete={this.onFilepondProcess('coverArtUrl')}
          onUploadRemove={this.onFilepondFileRemove('coverArtUrl')}
          onUploadError={this.onFilepondFileRemove('coverArtUrl')}
          onFileRemove={this.onFileForceRemove('coverArtUrl')}
          onImportComplete={this.onFileImportComplete('coverArtUrl')}
          onImportRemove={this.onFileImportRemove('coverArtUrl')}
          onImportError={this.onFileImportRemove('coverArtUrl')}
          persistUploaderOnSuccess={!editmode}
        />
        {this.renderReleaseInterval()}
        {editmode && this.renderAudioEditor()}
        {this.renderAudioProcessing()}
        {this.renderSaveButtons()}
        <BeforeUnload dirty={dirty || saving} />
      </>
    );
  }
}

SingleEpisode.propTypes = {
  userInfo: PropTypes.object,
  soundcastsManaged: PropTypes.array,
  history: PropTypes.object,
  saving: PropTypes.bool,
  editmode: PropTypes.bool,
  realSaveEpisode: PropTypes.func,
  onDeleteEpisode: PropTypes.func,
  modalHandler: PropTypes.func,
};

SingleEpisode.defaultProps = {
  userInfo: {},
  soundcastsManaged: [],
  history: {},
  saving: false,
  editmode: false,
  realSaveEpisode: () => {},
  onDeleteEpisode: () => {},
  modalHandler: () => {},
};

export default SingleEpisode;
